import { CommonModule } from '@angular/common';
import { Component, EventEmitter, HostListener, Input, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { SelectModule } from 'primeng/select';

@Component({
  selector: 'app-qr-code-preview-modal',
  standalone: true,
  imports: [CommonModule, FormsModule, SelectModule],
  templateUrl: './qr-code-preview-modal.component.html',
  styleUrls: ['./qr-code-preview-modal.component.scss'],
})
export class QrCodePreviewModalComponent {
  @Input() qrToken: string | null = null;
  @Input() label: string = '';
  @Output() close = new EventEmitter<void>();

  public readonly qrDimensions = [64, 128, 256, 512, 1024];
  public readonly qrDimensionOptions = this.qrDimensions.map(dimension => ({
    label: `${dimension} x ${dimension} px`,
    value: dimension,
  }));
  public selectedQrDimension = 64;

  public onClose(): void {
    this.close.emit();
  }

  @HostListener('document:keydown.escape', ['$event'])
  public handleEscape(event: Event): void {
    if (!this.qrToken) return;
    const keyboardEvent = event as KeyboardEvent;
    keyboardEvent.preventDefault();
    this.onClose();
  }

  public getQrCodeImageUrl(size: number = this.selectedQrDimension): string {
    if (!this.qrToken) return '';
    return `https://api.qrserver.com/v1/create-qr-code/?size=${size}x${size}&data=${encodeURIComponent(this.qrToken)}`;
  }

  public downloadQrCode(): void {
    if (!this.qrToken) return;

    const fileNameSuffix = this.label ? `-${this.label}` : '';
    const fileName = `qr-token${fileNameSuffix}.png`;
    const downloadUrl = this.getQrCodeImageUrl(this.selectedQrDimension);

    fetch(downloadUrl)
      .then(response => {
        if (!response.ok) {
          throw new Error('Failed to fetch QR code');
        }
        return response.blob();
      })
      .then(blob => {
        const objectUrl = URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = objectUrl;
        link.download = fileName;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(objectUrl);
      })
      .catch(() => {
        const link = document.createElement('a');
        link.href = downloadUrl;
        link.target = '_blank';
        link.rel = 'noopener noreferrer';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      });
  }
}
